import { irsW8ben } from "./irs-w8ben.js";
import type { FormPack } from "./types.js";

/** Every form pack this build knows, by "id@revision". */
export const PACKS: Record<string, FormPack> = {
  [`${irsW8ben.id}@${irsW8ben.revision}`]: irsW8ben,
};

export function getPack(ref: string): FormPack {
  const p = PACKS[ref];
  if (!p) throw new Error(`Unknown form pack "${ref}"`);
  return p;
}

export { irsW8ben };
export type { FormPack, PackSection, SignatureSpot } from "./types.js";
export { countryName, countryOptions, COUNTRY_CODES, US_TERRITORIES } from "./countries.js";
